import { axios } from '@/lib'

export interface SchemaResponse {
  Data: Record[]
  Count: number
}

export interface Record {
  $type: string
  Index: string
  Icon?: string
  Name: string
  Schemas: Schema[]
  Attributes: Attribute[]
  IsAccount: boolean
  IsResource: boolean
  IsSearchable: boolean
}

export interface Attribute {
  Name: string
  DisplayName: string
  DataType: DataType
  IsMultiValued?: boolean
}

export enum DataType {
  Reference = 'Reference',
  Undefined = 'Undefined',
}

export interface Schema {
  Name: string
  DisplayName: string
  AnchorAttributes: any[]
  Attributes: number[]
}

export async function getSchema() {
  const { data } = await axios.get<SchemaResponse>('/api/projected/schema')
  return data
}
